<template>
  <b-modal
    fluid
    centered
    size="md"
    ref="speaker"
    id="saveschedule"
    title="Save my schedule"
    hide-footer
  >
    <div v-if="!$route.params.id">
      <b-form @submit="saveSchedule">
        <b-form-group
          id="input-group-1"
          label="Email address:"
          label-for="input-1"
          description="You will receive an email with a link to your schedule"
        >
          <b-form-input
            id="input-1"
            v-model="form.email"
            type="email"
            required
            placeholder="Enter email"
          >
          </b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn btn-lime-green">Submit</b-button>
      </b-form>
    </div>
    <div v-else>
      <p><b>Thanks for saving your schedule</b></p>
      <p>Please have a look in your inbox.</p>
    </div>
  </b-modal>
</template>

<script>
import schedule from "@/mixins/schedule";

export default {
  name: "EmailModal",
  mixins: [schedule],
  data() {
    return {
      form: {
        email: "",
      },
    };
  },
  methods: {
    saveSchedule: function (evt) {
      evt.preventDefault();
      const email = this.form.email;
      if (email) {
        this.schedule_createSchedule(email);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/EmailModal.vue